module.exports = __webpack_public_path__ + "img/file-arrow-up.3e5dd6ee.svg";